module.exports = __webpack_public_path__ + "img/quac.39394ab3.svg";